// extracted by mini-css-extract-plugin
export default {"Main":"FooterMain_Main__rCzPv"};